import React, { Component } from "react";
import { Grid } from "@mui/material";
import SelectGenre from "./selectgenre";
import { connect } from "react-redux";
import {
  editBandGenre2,
  editBandIsSecondGenre,
} from "../actions/editbandactions";

class SecondGenre extends Component {
  constructor(props) {
    super(props);
    this.renderSecondGenre = this.renderSecondGenre.bind(this);
    this.renderCheckMark = this.renderCheckMark.bind(this);
    this.clickOnCheckBox = this.clickOnCheckBox.bind(this);
    this.setSelected = this.setSelected.bind(this);
    this.isSecondGenre = this.isSecondGenre.bind(this);
    this.setGenre = this.setGenre.bind(this);
  }

  isSecondGenre(isSecondGenre) {}

  setSelected(genre) {}

  clickOnCheckBox(check) {
    const { dispatch } = this.props;

    dispatch(editBandIsSecondGenre(check));
  }

  renderCheckMark() {
    const { is_second_genre } = this.props;

    if (is_second_genre) {
      return (
        <Grid item xs={12}>
          <span class="checkmark" onClick={() => this.clickOnCheckBox(false)}>
            <div class="checkmark_circle_selected"></div>
            <div class="checkmark_stem"></div>
            <div class="checkmark_kick"></div>
          </span>
        </Grid>
      );
    } else {
      return (
        <Grid item xs={12}>
          <span class="checkmark" onClick={() => this.clickOnCheckBox(true)}>
            <div class="checkmark_circle"></div>
          </span>
        </Grid>
      );
    }
  }

  setGenre(genre) {
    const { dispatch } = this.props;

    dispatch(editBandGenre2(genre));
  }

  renderSecondGenre() {
    const { is_second_genre, genre2, unsavedSecondGenre, genre1 } = this.props;

    if (is_second_genre) {
      return (
        <React.Fragment>
          <Grid item xs={12}>
            <label className="label">{`Genre 2 ${
              unsavedSecondGenre ? "*" : ""
            }`}</label>
          </Grid>
          <Grid item xs={12}>
            <SelectGenre
              setGenre={this.setGenre}
              genre={genre2}
              excluded={genre1}
            />
          </Grid>
        </React.Fragment>
      );
    }

    return <React.Fragment />;
  }

  render() {
    const { unsavedIsSecondGenre } = this.props;

    return (
      <React.Fragment>
        <Grid item xs={12}>
          <label className="label">{`Genre 2 ? ${
            unsavedIsSecondGenre ? "*" : ""
          }`}</label>
        </Grid>
        <Grid item xs={12}>
          {this.renderCheckMark()}
        </Grid>
        <Grid item xs={12}>
          <br />
        </Grid>
        {this.renderSecondGenre()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  is_second_genre: state.editband.is_second_genre,
  genre2: state.editband.genre2,
  genre1: state.editband.genre1,
});

export default connect(mapStateToProps)(SecondGenre);
